export default function singleProductGallery() {
    const flex_control_nav_items = document.querySelectorAll('.flex-control-nav li');
    flex_control_nav_items[0].classList.add('active');

    flex_control_nav_items.forEach(item => {
        item.addEventListener('click', function () {
            reset();
            this.classList.add('active');
        })
    });

    function reset() {
        flex_control_nav_items.forEach(item => {
            item.classList.remove('active');
        });
    }
}